import { api } from './index'
import { unwrap } from './client'

/** What the websocket server wants back: `key:signature`. */
export interface ChannelAuthorisation {
  auth: string
}

/**
 * Asks the API to sign this session into a live-update channel (MRS 6.15).
 * An operator may join `private-operator` only; anything else is a 403
 * `channel_forbidden`, and 503 `live_updates_unavailable` means the
 * environment has no websocket app. The bearer token is read by the client at
 * the moment of the call.
 */
export async function authoriseChannel(
  socketId: string,
  channelName: string,
): Promise<ChannelAuthorisation> {
  return unwrap<ChannelAuthorisation>(
    await api.POST('/api/v1/auth/broadcasting', {
      body: { socket_id: socketId, channel_name: channelName },
    }),
  )
}
